import React from 'react';
import { Container, Nav, Navbar,Button } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';



const Header = () => {
    return (
        <div id='home'>
    <Navbar fixed='top' collapseOnSelect expand="lg"  style={{backgroundColor:'#CBDCDC'}}>
  <Container>
  <Navbar.Brand to="#home" style={{fontWeight:'bold',fontFamily:'cursive',color:'black'}} >Hridoy Ahmed<span style={{fontWeight:'bold', fontSize:'30px'}}>.</span></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="me-auto">     
    </Nav>
    <Nav>
     <Nav.Link as={HashLink}  style={{textDecoration:'none',fontSize:'18px',color:'black',marginRight:'20px',fontWeight:'bold'}}  to='/#home'>Home</Nav.Link>
      <Nav.Link as={HashLink} style={{textDecoration:'none',fontSize:'18px',color:'black',marginRight:'20px',fontWeight:'bold'}} to='/#about'>About</Nav.Link>
     <Nav.Link as={HashLink} style={{textDecoration:'none',fontSize:'18px',color:'black',marginRight:'20px',fontWeight:'bold'}} to='/#service'>Service</Nav.Link>
     <Nav.Link as={HashLink} style={{textDecoration:'none',fontSize:'18px',color:'black',marginRight:'20px',fontWeight:'bold'}} to='/#project'>Project</Nav.Link>
     <Nav.Link as={HashLink} to='/#contact' style={{textDecoration:'none',fontSize:'18px',color:'black',marginRight:'20px',fontWeight:'bold'}}>Contact</Nav.Link>
     <Nav.Link as={HashLink} to="/blogs" style={{textDecoration:'none',fontSize:'18px',color:'black',marginRight:'20px',fontWeight:'bold'}}>Blog</Nav.Link>
     
    </Nav>
    
   <a target='blank' href="https://drive.google.com/file/d/1e9fgPCb8GzyaC4zZdtlVw8ZB8Xsv9VtM/view?usp=sharing"><Button variant="outline-secondary">Download Resume</Button></a>
  </Navbar.Collapse>
  </Container>
</Navbar>
        </div>
    );
};

export default Header;